import { z } from 'zod'

export const createTenantSchema = z.object({
  name: z.string().min(2).max(64),
  slug: z.string().min(3).max(48).regex(/^[a-z0-9-]+$/, 'Lowercase alphanumeric and dashes only'),
})

export const createSiteSchema = z.object({
  name: z.string().min(1).max(64),
  subdomain: z.string().min(3).max(48).regex(/^[a-z0-9-]+$/, 'Lowercase alphanumeric and dashes only'),
})

export const createPageSchema = z.object({
  title: z.string().min(1).max(128),
  slug: z.string().min(1).max(128).regex(/^[a-z0-9-/]+$/, 'Lowercase alphanumeric, dashes, and slashes only'),
  isHome: z.boolean().optional(),
})

export const updateSiteSettingsSchema = z.object({
  primaryColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
  secondaryColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
  fontHeading: z.string().max(64).optional(),
  fontBody: z.string().max(64).optional(),
  logo: z.string().url().optional().or(z.literal('')),
  favicon: z.string().url().optional().or(z.literal('')),
})

export const pageMetaSchema = z.object({
  title: z.string().max(70).optional(),
  description: z.string().max(160).optional(),
  ogImage: z.string().url().optional().or(z.literal('')),
  noIndex: z.boolean().optional(),
})

export type CreateTenantDTO = z.infer<typeof createTenantSchema>
export type CreateSiteDTO = z.infer<typeof createSiteSchema>
export type CreatePageDTO = z.infer<typeof createPageSchema>
export type UpdateSiteSettingsDTO = z.infer<typeof updateSiteSettingsSchema>
export type PageMetaDTO = z.infer<typeof pageMetaSchema>
